export const convertImageUrlToDataUrl = url =>
  fetch(url)
    .then(response => response.blob())
    .then(
      blob =>
        new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.onload = () => {
            resolve(fileReader.result);
          };
          fileReader.onerror = reject;
          fileReader.readAsDataURL(blob);
        })
    );

export const downloadFromUrl = url =>
  convertImageUrlToDataUrl(url).then(dataUrl => {
    const element = document.createElement('a');
    element.href = dataUrl;
    element.download = url.substr(url.lastIndexOf('/') + 1);
    document.body.appendChild(element);
    element.click();

    document.body.removeChild(element);
  });
